(function() {
    import("angular").then(angular => {
        var app = angular.module("tapAssetManager");

        app.directive("assetShareButtons", [
            "assetEmbedCodeGenerator",
            "sharerTwitter",
            "TranslationService",
            "$uibModal",
            function(assetEmbedCodeGenerator, sharerTwitter, TranslationService, $uibModal) {
                return {
                    restrict: "E",
                    templateUrl: "/bundles/tapsite/html/tap-asset-manager/browser/asset-share-buttons.html",
                    scope: {
                        asset: "=",
                        selectedData: "=",
                        setLoading: "=",
                        buttonStyle: "@",
                        textContent: "@",
                        facebookSharingDisabled: "=",
                        twitterSharingDisabled: "=",
                    },
                    controller: function($scope) {
                        $scope.enabledButtons = $scope.enabledButtons || [];
                        var buttons = [];
                        switch ($scope.asset.type) {
                            case "image_banner":
                                buttons = ["pinterest", "facebook"];
                                if (!$scope.twitterSharingDisabled) buttons.push("twitter");
                                break;
                            case "referral_link":
                                buttons = ["twitter", "facebook", "pinterest", "email", "linkedin"];
                                break;
                            case "facebook_post":
                                buttons = ["facebook"];
                                break;
                            case "text_link":
                                buttons = ["twitter", "facebook", "linkedin", "email"];
                                break;
                            case "tweet":
                                buttons = ["twitter"];
                                break;
                            case "vimeo_video":
                                buttons = ["facebook"];
                                break;
                            case "youtube_video":
                                buttons = ["facebook"];
                                break;
                        }

                        $scope.enabledButtons = buttons;

                        $scope.hasButton = function(name) {
                            return $scope.enabledButtons.indexOf(name) > -1;
                        };

                        $scope.hasStyle = function(name) {
                            var style = $scope.buttonStyle || "default";

                            return style === name;
                        };

                        $scope.setCurrentLink = function(asset) {
                            $scope.currentLink = assetEmbedCodeGenerator.generate(
                                asset,
                                $scope.selectedData.selectedSource,
                                $scope.referralCode,
                                $scope.selectedData.metaData,
                                { linkOnly: true },
                            );
                        };

                        $scope.shareToTwitter = function(asset) {
                            if ($scope.twitterSharingDisabled) {
                                var summary =
                                    ["text_link", "tweet"].indexOf(asset.type) > -1 ? asset.content : "Check this out";
                                var url =
                                    "http://twitter.com/home?status=" +
                                    encodeURIComponent(summary) +
                                    " " +
                                    encodeURIComponent($scope.currentLink);
                                window.open(
                                    url,
                                    "popup",
                                    "width=600,height=700,scrollbars=yes,resizable=yes,toolbar=no,directories=no,location=no,menubar=no,status=no",
                                );
                                return;
                            }

                            $scope.setCurrentLink(asset);

                            function showModal() {
                                $scope.setLoading(false);
                                $scope.shareModal = $uibModal.open({
                                    animation: false,
                                    templateUrl: "/bundles/tapsite/html/tap-asset-manager/browser/sharer-twitter.html",
                                    controller: "sharerTwitterCtrl",
                                    scope: $scope,
                                });
                            }

                            function getDetailsAndShowModal() {
                                $scope.setLoading(true);
                                sharerTwitter.getUserDetails(function(err, result) {
                                    if (result === false) {
                                        sharerTwitter.authorize(null, function(result) {
                                            if (result) getDetailsAndShowModal();

                                            $scope.setLoading(false);
                                        });
                                    } else {
                                        $scope.twitter = $scope.twitter || {};
                                        $scope.twitter.userDetails = result;
                                        showModal();
                                    }
                                });
                            }

                            getDetailsAndShowModal();
                        };

                        $scope.shareToFacebook = function(asset) {
                            if ($scope.facebookSharingDisabled) {
                                var url =
                                    "https://www.facebook.com/share.php?u=" + encodeURIComponent($scope.currentLink);
                                window.open(
                                    url,
                                    "popup",
                                    "width=600,height=700,scrollbars=yes,resizable=yes,toolbar=no,directories=no,location=no,menubar=no,status=no",
                                );
                                return;
                            }

                            let params = {
                                method: "share",
                                display: "popup",
                            };

                            switch (asset.type) {
                                case "image_banner":
                                case "vimeo_video":
                                case "youtube_video":
                                    params.href = asset.type_details.url;
                                    params.quote = `${$scope.currentLink} <= ${TranslationService.trans(
                                        "asset.sharer.fb_sharing_instructions",
                                    )}`;
                                    break;

                                case "referral_link":
                                    params.href = $scope.currentLink;
                                    break;

                                case "facebook_post":
                                case "text_link":
                                    params.href = $scope.currentLink;
                                    params.quote = asset.content;
                            }

                            FB.ui(params);
                        };

                        $scope.shareToPinterest = function(asset) {
                            var url =
                                "https://pinterest.com/pin/create/button/?url=" +
                                encodeURIComponent($scope.currentLink) +
                                "&media=" +
                                encodeURIComponent(asset.type_details.url) +
                                "&description=";
                            window.open(
                                url,
                                "popup",
                                "width=600,height=700,scrollbars=yes,resizable=yes,toolbar=no,directories=no,location=no,menubar=no,status=no",
                            );
                        };

                        $scope.shareToLinkedIn = function(asset) {
                            var summary = asset.type === "text_link" ? asset.content : "Check this out";
                            var url =
                                "https://www.linkedin.com/shareArticle?mini=true&url=" +
                                encodeURIComponent($scope.currentLink) +
                                "&summary=" +
                                encodeURIComponent(summary) +
                                "&source=" +
                                encodeURIComponent($scope.currentLink);

                            window.open(
                                url,
                                "popup",
                                "width=600,height=700,scrollbars=yes,resizable=yes,toolbar=no,directories=no,location=no,menubar=no,status=no",
                            );
                        };

                        $scope.getPreviewImageUrl = function(asset) {
                            switch (asset.type) {
                                case "youtube_video":
                                    return "https://img.youtube.com/vi/" + asset.type_details.video_id + "/0.jpg";
                                    break;
                                case "vimeo_video":
                                    return "https://i.vimeocdn.com/video/" + asset.type_details.video_id + "_640.webp";
                                    break;
                                default:
                                    return asset.type_details.url;
                                    break;
                            }
                        };
                    },
                };
            },
        ]);

        app.directive("vimeoThumb", [
            "$q",
            "$http",
            function($q, $http) {
                function loadImage(id) {
                    var deferred = $q.defer();

                    $http
                        .jsonp("https://vimeo.com/api/v2/video/" + id + ".json?callback=JSON_CALLBACK")
                        .success(function(data) {
                            var thumbs = {};
                            thumbs.small = data[0]["thumbnail_small"];
                            thumbs.medium = data[0]["thumbnail_medium"];
                            thumbs.large = data[0]["thumbnail_large"];
                            deferred.resolve(thumbs);
                        })
                        .error(function() {
                            deferred.reject();
                        });

                    return deferred.promise;
                }

                return {
                    scope: {
                        asset: "=",
                    },
                    link: function(scope, el) {
                        loadImage(scope.asset.type_details.video_id).then(function(thumbs) {
                            angular.element(el).css("background-image", "url(" + thumbs.large + ")");
                        });
                    },
                };
            },
        ]);
    });
})();
